import { Check } from "lucide-react";
import { STAGES } from "../../../data/quotationsData";

export default function StatusStepper({ status }) {
  const currentIndex = STAGES.indexOf(status);

  return (
    <div className="flex items-center flex-wrap gap-y-3">
      {STAGES.map((stage, index) => {
        const isComplete = index < currentIndex;
        const isCurrent = index === currentIndex;

        return (
          <div key={stage} className="flex items-center">
            <div className="flex items-center gap-1.5">
              <div
                className={`w-6 h-6 rounded-full flex items-center justify-center text-[11px] font-bold shrink-0 ${
                  isComplete
                    ? "bg-green-500 text-white"
                    : isCurrent
                    ? "bg-indigo-600 text-white"
                    : "bg-gray-100 text-gray-400"
                }`}
              >
                {isComplete ? <Check className="w-3.5 h-3.5" /> : index + 1}
              </div>
              <span
                className={`text-xs whitespace-nowrap ${
                  isCurrent
                    ? "font-semibold text-gray-900"
                    : isComplete
                    ? "text-gray-600"
                    : "text-gray-400"
                }`}
              >
                {stage}
              </span>
            </div>
            {index < STAGES.length - 1 && (
              <div
                className={`h-px w-6 mx-2 ${
                  isComplete ? "bg-green-400" : "bg-gray-200"
                }`}
              />
            )}
          </div>
        );
      })}
    </div>
  );
}